import React from 'react'

import QRCode from 'qrcode.react'
import { Grid, Header, Button } from 'semantic-ui-react'

import { IProject } from '../../../api/Data'

import ExternalLink from '../../../components/common/ExternalLink'

const CollaborateTab = ({ project }: IProps) => {
  const downloadQR = () => {
    const canvas: any = document.getElementById('qr-code')

    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `${project.title.replace(/ /g, '-')}-qr-code.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  const { projectUrl } = project

  const projectLinkForQRCode = `${projectUrl}?utm_source=qrcode` // utm is used to differentiate direct form qrcode scan

  return (
    <div style={{ textAlign: 'center' }}>
      <Header as="h2" style={{ fontWeight: 'bold' }}>
        By using this QR code
      </Header>
      
      <Grid columns={1} verticalAlign="middle" stackable>
        <Grid.Column>
          <Header as="h4">
            <Header.Subheader>
              Use a on-location poster with this QR code to prompt people to upload their videos to your project.
            </Header.Subheader>
          </Header>
        </Grid.Column>

        <Grid.Column>
          <QRCode value={projectLinkForQRCode} />
          {/* TODO: This hidden QR code is used to download a higher resolution version of the QR code above, there is probably another method to use to avoid having to render 2 QRCODEs.  */}
          <QRCode id="qr-code" size={512} value={projectLinkForQRCode} style={{ display: 'none' }} />
        </Grid.Column>

        <Grid.Column>
          <Button compact primary onClick={downloadQR}>
            Download QR Code
          </Button>
        </Grid.Column>

        <Grid.Column>
          <ExternalLink url="https://vloggi.com/docs/using-vloggis-qr-codes-to-collect-video-footage-at-physical-events-a-comprehensive-guide/">Read more</ExternalLink>
        </Grid.Column>
      </Grid>
    </div>
  )
}

interface IProps {
  project: IProject
}

export default CollaborateTab
